import React, { Component } from "react";
import { connect } from "react-redux";
import "./App.css";
import { HashRouter as Router, Route, Switch } from "react-router-dom";

import { AlertMessage } from "./common/Utilities";
import { toggleShowAlert } from "./store/actions/commonActions";

import Main from "./components/layout/Main";
import Login from "./components/auth/Login";
import ResetPassword from "./components/auth/ResetPassword";
import ResendVerificationCode from "./components/auth/ResendVerificationCode";

class App extends Component {
  getReportRoutes = (report, key) => {
    return (
      <Route
        exact
        path={"/reports/" + report.link}
        component={Main}
        key={key}
      />
    );
  };

  render() {
    const reportLinks = [
      { link: "weekly-monthly-reports", name: "Weekly / Monthly Reports" },
      { link: "project-run-rate", name: "Project Run Rate" },
      { link: "missing-entries", name: "Missing Entries" },
      {
        link: "project-timesheet-cumulative",
        name: "Project Timesheet Cumulative",
      },
      { link: "profitability-per-project", name: "Profitability Per Project" },
      { link: "profitability-per-client", name: "Profitability Per Client" },
      { link: "productivity-report", name: "Productivity Report" },
      { link: "accomplishment-report", name: "Accomplishment Report" },
    ];

    const reportRoutes = reportLinks.map((report, key) =>
      this.getReportRoutes(report, key)
    );

    return (
      <div className="App">
        <AlertMessage
          show={this.props.common.showAlert}
          onCloseFunc={() => {
            if (this.props.common.showAlert === true) {
              this.props.toggleShowAlert(false);
            }
          }}
          type={this.props.common.alertType}
          message={this.props.common.alertMessage}
        />
        <Router>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <Route
              exact
              path="/resend-verification-code"
              component={ResendVerificationCode}
            />

            <Route exact path="/dashboard" component={Main} />

            <Route exact path="/approvals" component={Main} />

            <Route exact path="/projects" component={Main} />
            <Route exact path="/projects/disabled" component={Main} />
            <Route exact path="/projects/add" component={Main} />
            <Route exact path="/projects/wizard" component={Main} />
            <Route exact path="/projects/view" component={Main} />
            <Route exact path="/projects/update" component={Main} />
            <Route exact path="/projects/tasks" component={Main} />
            <Route exact path="/projects/tasks/view" component={Main} />
            <Route exact path="/projects/for-approval" component={Main} />

            <Route exact path="/timesheet" component={Main} />
            <Route exact path="/timesheet/add" component={Main} />
            <Route exact path="/timesheet/update" component={Main} />
            <Route exact path="/timesheet/approval" component={Main} />

            {/* <Route exact path="/dailytasks" component={Main} /> */}
            <Route exact path="/dailytasks/list" component={Main} />
            <Route exact path="/dailytasks/add" component={Main} />
            <Route exact path="/dailytasks/view" component={Main} />
            <Route exact path="/dailytasks/details" component={Main} />

            <Route exact path="/teamdailytasks" component={Main} />

            <Route exact path="/settings/users" component={Main} />
            <Route exact path="/settings/users/disabled" component={Main} />
            <Route exact path="/settings/users/add" component={Main} />
            <Route exact path="/settings/users/update" component={Main} />
            <Route exact path="/users/change-password" component={Main} />

            <Route exact path="/settings/platforms" component={Main} />
            <Route exact path="/settings/platforms/view" component={Main} />
            <Route exact path="/settings/platforms/add" component={Main} />
            <Route exact path="/settings/platforms/update" component={Main} />

            <Route exact path="/settings/clients" component={Main} />
            <Route exact path="/settings/clients/add" component={Main} />
            <Route exact path="/settings/clients/update" component={Main} />

            <Route exact path="/settings/holidays" component={Main} />
            <Route exact path="/settings/holidays/add" component={Main} />
            <Route exact path="/settings/holidays/update" component={Main} />

            <Route exact path="/settings/tasks" component={Main} />
            <Route exact path="/settings/tasks/add" component={Main} />
            <Route exact path="/settings/tasks/update" component={Main} />
            <Route exact path="/settings/tasks/disabled" component={Main} />

            <Route exact path="/settings/costcenters" component={Main} />
            <Route exact path="/settings/costcenters/add" component={Main} />
            <Route exact path="/settings/costcenters/update" component={Main} />

            <Route exact path="/reports" component={Main} />
            {reportRoutes}
          </Switch>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
});

const mapStateToDispatch = (dispatch) => {
  return {
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(App);
